type NextStepsMobileExtras = {
  openWebRedirect?: () => void;
  needsWebLogin?: boolean;
};

export function getPlatformNextStepsProps(
  platform: 'web' | 'mobile',
  options: { openWebRedirect?: () => void },
): NextStepsMobileExtras | {} {
  return platform === 'mobile'
    ? {
        openWebRedirect: options.openWebRedirect,
        needsWebLogin: true,
      }
    : {};
}
